/* eslint-disable jsx-a11y/anchor-is-valid */
import { Empty, List, Table, Tag, Typography } from 'antd';
import moment from 'moment';
import { Test } from 'procura-shared';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { RunTestButton } from './RunTestButton';

type TestsTableProps = {
  tests?: Test[];
  loading?: boolean;
};

export const TestsTable = ({ tests = [], loading = false }: TestsTableProps) => {
  const { t } = useTranslation();

  const isBigTable = (): Boolean => (noData() ? false : tests.length > 12);
  const noData = (): Boolean => tests == null || tests.length === 0;

  // const testClickHandler = (test: test) => {
  //   onSelect?.(test);
  // };

  const testResult = (test: Test): string => `${test.items - (test.failed?.length ?? 0)}/${test.items}`;

  const tableData = () =>
    tests.sort((x, y) => y.timestamp - x.timestamp).map((item, index) => ({ ...item, key: index }));

  const tableColumns = () => [
    {
      title: t('time'),
      dataIndex: 'timestamp',
      key: 'timestamp',
      render: (text: string) => moment(text).fromNow(),
    },
    {
      title: t('result'),
      dataIndex: 'success',
      key: 'success',
      render: (text: string, test: any) =>
        test.success ? (
          <Tag color="success">{`${t('success')} (${testResult(test)})`}</Tag>
        ) : (
          <Tag color="error">{`${t('failed')} (${testResult(test)})`}</Tag>
        ),
    },
    {
      title: t('type'),
      dataIndex: 'type',
      key: 'type',
    },
  ];

  const tableExpandable = () => ({
    expandedRowRender: (test: Test) => (
      <List size="small">
        {test.failed.map((failedItem, index) => (
          <List.Item key={index.toString()}>
            <Typography.Text code type="danger">
              [{failedItem.id}] {failedItem.reasons}
            </Typography.Text>
          </List.Item>
        ))}
      </List>
    ),
    rowExpandable: (test: Test) => !test.success,
  });

  return (
    <div>
      {!loading && noData() ? (
        <Empty />
      ) : (
        <>
          <p>{t('testsDescription')}</p>
          <RunTestButton type="Investments" />
          <Table
            pagination={false}
            loading={loading}
            bordered
            dataSource={tableData()}
            columns={tableColumns()}
            expandable={tableExpandable()}
            scroll={{ y: 500 }}
            sticky
            size={isBigTable() ? 'small' : 'large'}
          />
        </>
      )}
    </div>
  );
};
